// extracted by mini-css-extract-plugin
export default {"container":"styles_container__fkr8G","Box":"styles_Box__f8XrT"};